export default __webpack_public_path__ + "static/media/white-light1.289662bb.jpg";